// extracted by mini-css-extract-plugin
export var content = "FullWidthContentCell-module--content--pOzfE";
export var contentWrapper = "FullWidthContentCell-module--content-wrapper--pcDJb";
export var fullWidthContentCell = "FullWidthContentCell-module--full-width-content-cell--TznJa";